(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component__pagination-native"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('native-page-pagination')) {
    customElements.define('native-page-pagination', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.querySelector('form');
        this.input = this.querySelector('.pagination-page-input');
        if (!this.form || !this.input) return;
        this.controller = new AbortController();
        this.navigating = false;
        const { signal } = this.controller;

        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.navigate(event.submitter);
        }, { signal });
        this.input.addEventListener('change', () => this.navigate(), { signal });
        this.input.addEventListener('keydown', event => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.navigate();
        }, { signal });
        window.addEventListener('pageshow', () => {
          this.navigating = false;
          this.form.removeAttribute('aria-busy');
        }, { signal });
      }

      navigate(submitter) {
        if (this.navigating || submitter?.disabled) return;
        const pageParam = this.dataset.pageParam || 'page';
        const currentPage = Math.max(1, Number(this.dataset.currentPage) || 1);
        const totalPages = Math.max(1, Number(this.dataset.totalPages) || 1);
        const value = submitter?.name === pageParam ? submitter.value : this.input.value;
        const number = Number(value);
        const nextPage = value !== '' && Number.isFinite(number)
          ? Math.max(1, Math.min(totalPages, Math.floor(number)))
          : currentPage;
        this.input.value = String(nextPage);
        if (nextPage === currentPage) return;

        const url = new URL(this.form.action, window.location.href);
        url.search = window.location.search;
        url.searchParams.delete('section_id');
        url.searchParams.set(pageParam, String(nextPage));
        this.navigating = true;
        this.form.setAttribute('aria-busy', 'true');
        window.location.assign(url.href);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.navigating = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom__product-colorway-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.swapwearProductNavigation) return;

  const mainSelector = '#root [data-product-colorway-main]';
  const sectionSelector = '#root [data-product-colorway-section]';
  let activeController;
  let historyNavigationPending = false;
  let requestId = 0;
  let renderedUrl = window.location.href;
  const loadedScripts = new Set(Array.from(document.querySelectorAll('script[src]'), script => script.src));
  const reviewSelector = '.jdgm-review-widget[data-entry-key="review-widget/main.js"]';
  const reviewModules = new Map();
  const reviewMounts = new WeakMap();

  const loadReviewModule = (baseUrl) => {
    if (!reviewModules.has(baseUrl)) {
      const pending = fetch(new URL('manifest.json', baseUrl).href).then(async response => {
        if (!response.ok) throw new Error(`Review assets returned HTTP ${response.status}`);
        const manifest = await response.json();
        const entry = manifest['review-widget/ReviewWidgetManager.js'];
        if (!entry?.file) throw new Error('Review widget manager is unavailable');

        // Resolve the installed app version, including its styles, from its own
        // manifest. Replaying review_widget.js would remount every review widget.
        const visited = new Set();
        const loadStyles = (key) => {
          if (visited.has(key)) return;
          visited.add(key);
          const asset = manifest[key];
          (asset?.css || []).forEach(file => {
            const href = new URL(file, baseUrl).href;
            if (Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(link => link.href === href)) return;
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
          });
          (asset?.imports || []).forEach(loadStyles);
        };
        loadStyles('review-widget/main.js');
        const moduleUrl = new URL(entry.file, baseUrl);
        return import(moduleUrl.href);
      }).catch(error => {
        reviewModules.delete(baseUrl);
        throw error;
      });
      reviewModules.set(baseUrl, pending);
    }
    return reviewModules.get(baseUrl);
  };

  const destroyReviews = (section) => {
    section.querySelectorAll(reviewSelector).forEach(widget => {
      reviewMounts.delete(widget);
      widget.__vue_app__?.unmount();
    });
  };

  const initializeReviews = (sections) => {
    const baseUrl = window.jdgm?.CDN_BASE_URL;
    if (!baseUrl || !window.jdgmSettings?.review_widget_revamp_enabled) return;
    sections.flatMap(section => Array.from(section.querySelectorAll(reviewSelector))).forEach(widget => {
      if (widget.__vue_app__ || reviewMounts.has(widget)) return;
      const mount = {};
      reviewMounts.set(widget, mount);
      const isCurrentWidget = () => widget.isConnected && reviewMounts.get(widget) === mount;
      widget.setAttribute('aria-busy', 'true');
      void loadReviewModule(baseUrl).then(async ({ ReviewWidgetManager }) => {
        if (!isCurrentWidget() || widget.__vue_app__) return;
        // Judge.me's revamp entry runs once per document. Its exported manager
        // mounts just this replacement using the incoming product's data script.
        const manager = new ReviewWidgetManager(widget);
        const createWidget = manager.createReviewWidget.bind(manager);
        manager.createReviewWidget = (...args) => {
          // Locale/review requests can finish after another color was selected.
          if (!isCurrentWidget()) return null;
          // initialize() clears the container before calling this method. If
          // the initial app loader mounted meanwhile, replace that app cleanly.
          widget.__vue_app__?.unmount();
          return createWidget(...args);
        };
        await manager.initialize();
      }).catch(error => {
        console.warn('Unable to refresh product reviews', error);
      }).finally(() => {
        if (reviewMounts.get(widget) !== mount) return;
        reviewMounts.delete(widget);
        widget.removeAttribute('aria-busy');
      });
    });
  };

  const initializeScripts = (section) => {
    section.querySelectorAll('script[data-product-colorway-script], .shopify-app-block script').forEach(script => {
      if (script.type && !['text/javascript', 'application/javascript', 'module'].includes(script.type)) return;
      if (script.src && loadedScripts.has(script.src)) return;
      const replacement = document.createElement('script');
      Array.from(script.attributes).forEach(attribute => replacement.setAttribute(attribute.name, attribute.value));
      replacement.textContent = script.textContent;
      if (script.src) loadedScripts.add(script.src);
      script.replaceWith(replacement);
    });
  };

  const refreshHead = (section) => {
    const head = section.querySelector('[data-product-colorway-head]')?.content;
    if (!head) return;
    const selector = 'title, link[rel="canonical"], meta[name="description"], meta[property^="og:"], meta[name^="twitter:"], meta[itemprop], script[data-product-colorway-schema]';
    document.head.querySelectorAll(selector).forEach(node => node.remove());
    head.querySelectorAll(selector).forEach(node => document.head.appendChild(node.cloneNode(true)));
  };

  const refreshProductIntegrations = (main, sections) => {
    const product = window.Alpine.$data(main)?.product;
    window.Shopify?.PaymentButton?.init?.();
    initializeReviews(sections);
    sections.forEach(section => section.dispatchEvent(new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId: section.id.replace('shopify-section-', '') }
    })));
    window.dispatchEvent(new CustomEvent('product:colorway-updated', {
      detail: { product, url: window.location.href, sections }
    }));
    window.swapwearTrackSpaPageChange?.(window.location.href, { title: document.title, eventName: 'product_view' });
  };

  const navigate = async (url, options = {}) => {
    const targetUrl = new URL(url, window.location.origin);
    const main = document.querySelector(mainSelector);
    if (!main || targetUrl.origin !== window.location.origin || !window.Alpine?.mutateDom) {
      window.location.assign(targetUrl.href);
      return false;
    }

    const id = ++requestId;
    activeController?.abort();
    if (options.history !== 'none' && !historyNavigationPending &&
        targetUrl.pathname === new URL(renderedUrl).pathname && targetUrl.pathname === window.location.pathname) {
      main.removeAttribute('aria-busy');
      return true;
    }
    const controller = new AbortController();
    activeController = controller;
    historyNavigationPending = options.history === 'none';
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    const isCurrent = () => id === requestId;
    main.setAttribute('aria-busy', 'true');

    try {
      const sectionIds = [...new Set(Array.from(document.querySelectorAll(sectionSelector), node => node.dataset.productColorwaySection))];
      const batches = [];
      for (let offset = 0; offset < sectionIds.length; offset += 5) {
        const sectionUrl = new URL(targetUrl.href);
        sectionUrl.searchParams.delete('section_id');
        const previewTheme = window.Shopify?.theme;
        if (previewTheme?.id && ['development', 'unpublished'].includes(previewTheme.role)) {
          sectionUrl.searchParams.set('preview_theme_id', previewTheme.id);
        }
        sectionUrl.searchParams.set('sections', sectionIds.slice(offset, offset + 5).join(','));
        batches.push(fetch(sectionUrl.href, { signal: controller.signal, credentials: 'same-origin' }).then(response => {
          if (!response.ok) throw new Error(`Colorway sections returned HTTP ${response.status}`);
          return response.json();
        }));
      }
      const rendered = Object.assign({}, ...await Promise.all(batches));
      if (!isCurrent()) return false;

      const replacements = sectionIds.map(sectionId => {
        if (typeof rendered[sectionId] !== 'string' || !rendered[sectionId].trim()) {
          throw new Error(`Missing colorway section ${sectionId}`);
        }
        const sectionDocument = new DOMParser().parseFromString(rendered[sectionId], 'text/html');
        const sectionIdAttribute = `shopify-section-${sectionId}`;
        const current = document.getElementById(sectionIdAttribute);
        const next = sectionDocument.getElementById(sectionIdAttribute);
        if (!current || !next) throw new Error(`Invalid colorway section ${sectionId}`);
        return { current, next };
      });
      const nextMain = replacements.map(({ next }) => next.querySelector('[data-product-colorway-main]')).find(Boolean);
      const targetHandle = decodeURIComponent(targetUrl.pathname.split('/').filter(Boolean).pop());
      if (!nextMain || nextMain.dataset.productHandle !== targetHandle ||
          nextMain.dataset.productType !== main.dataset.productType ||
          nextMain.dataset.productTemplate !== main.dataset.productTemplate) {
        throw new Error('Colorway uses a different product layout');
      }

      const oldData = window.Alpine.$data(main);
      const selectedOptions = (oldData?.product?.options || []).map((name, index) => ({
        name, value: oldData[`option${index + 1}`]
      }));
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      const hadFocus = options.restoreFocus && main.contains(document.activeElement);

      const replaceSections = () => {
        if (!isCurrent()) return;
        if (options.history !== 'none') {
          window.history.pushState({ ...window.history.state }, '', targetUrl.href);
        }
        window.Alpine.mutateDom(() => {
          replacements.forEach(({ current, next }) => {
            current.dispatchEvent(new CustomEvent('shopify:section:unload', {
              bubbles: true,
              detail: { sectionId: current.id.replace('shopify-section-', '') }
            }));
            destroyReviews(current);
            window.Alpine.destroyTree(current);
            current.replaceWith(next);
          });
          replacements.forEach(({ next }) => initializeScripts(next));
        });
        replacements.forEach(({ next }) => window.Alpine.initTree(next));

        if (options.history !== 'none' && !targetUrl.searchParams.has('variant')) {
          const nextData = window.Alpine.$data(nextMain);
          let restored = false;
          (nextData?.product?.options || []).forEach((name, index) => {
            const value = selectedOptions.find(option => option.name === name)?.value;
            if (!value) return;
            const exists = nextData.product.variants.some(variant => nextData.handleize(variant[`option${index + 1}`]) === value);
            if (exists) {
              nextData[`option${index + 1}`] = value;
              restored = true;
            }
          });
          if (restored) nextData.handleProductFormChange(true);
        }

        renderedUrl = window.location.href;
        refreshHead(nextMain.closest('.shopify-section'));
        window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
        window.Alpine.nextTick(() => {
          if (!isCurrent()) return;
          if (hadFocus) {
            const swatches = Array.from(nextMain.querySelectorAll('[data-colorway-handle]'));
            const selected = swatches.find(swatch => swatch.dataset.colorwayHandle === targetHandle && swatch.getClientRects().length);
            selected?.focus({ preventScroll: true });
          }
          try {
            refreshProductIntegrations(nextMain, replacements.map(({ next }) => next));
          } catch (error) {
            console.warn('Unable to refresh optional colorway integrations', error);
          }
        });
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const transition = document.startViewTransition(replaceSections);
        await transition.updateCallbackDone;
      } else {
        replaceSections();
      }
      return isCurrent();
    } catch (error) {
      if (isCurrent()) window.location.assign(targetUrl.href);
      return false;
    } finally {
      window.clearTimeout(timeout);
      if (isCurrent()) {
        main.removeAttribute('aria-busy');
        activeController = null;
        historyNavigationPending = false;
      }
    }
  };

  window.swapwearProductNavigation = { navigate };
  const cancelPending = () => {
    requestId += 1;
    activeController?.abort();
    activeController = null;
    historyNavigationPending = false;
    document.querySelector(mainSelector)?.removeAttribute('aria-busy');
  };
  window.addEventListener('swapwear:spa-page-change', () => {
    if (window.history.state?.swapwearCartDrawer) cancelPending();
  });
  window.addEventListener('popstate', event => {
    if (!document.querySelector(mainSelector)) return;
    if (event.state?.swapwearCartDrawer) {
      cancelPending();
      return;
    }
    const previous = new URL(renderedUrl);
    const current = new URL(window.location.href);
    if (current.pathname === previous.pathname && current.search === previous.search) {
      cancelPending();
      return;
    }
    void navigate(current.href, { history: 'none' });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product__title"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-title-fit')) {
    customElements.define('product-title-fit', class extends HTMLElement {
      connectedCallback() {
        this.heading = this.querySelector('.product-title__heading');
        this.frame = null;
        this.scheduleFit = () => {
          if (this.frame !== null || !this.isConnected) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (!this.isConnected || !this.heading) return;
            this.heading.style.fontSize = '';
            const available = this.heading.clientWidth;
            const natural = this.heading.scrollWidth;
            if (available > 0 && natural > available) {
              const fontSize = parseFloat(getComputedStyle(this.heading).fontSize);
              this.heading.style.fontSize = `${Math.floor(fontSize * (available - 1) / natural * 10) / 10}px`;
            }
          });
        };
        this.observer = new ResizeObserver(this.scheduleFit);
        this.observer.observe(this);
        window.addEventListener('resize', this.scheduleFit);
        document.fonts?.addEventListener('loadingdone', this.scheduleFit);
        document.fonts?.ready.then(() => this.scheduleFit());
        this.scheduleFit();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.frame = null;
        window.removeEventListener('resize', this.scheduleFit);
        document.fonts?.removeEventListener('loadingdone', this.scheduleFit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
